import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  ForgotCredentialFormComponent,
  ForgotCredentialType,
} from '../forgot-credential-form/forgot-credential-form.component';
import { ApiResponse } from '@shared/models/api-response.model';
import { showAuthErrorSwal, showAuthSuccessSwal } from '@shared/utils/auth-swal.util';
import { environment } from '@env/environment';

@Component({
  selector: 'app-forgot-credential',
  standalone: true,
  imports: [CommonModule, TranslateModule, ForgotCredentialFormComponent],
  templateUrl: './forgot-credential.component.html',
  styleUrl: './forgot-credential.component.scss',
})
export class ForgotCredentialComponent implements OnInit {
  type: ForgotCredentialType = 'password';
  isQP23 = ['qp23'].includes(environment.projectCode.toLowerCase());

  private readonly isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      const t = params.get('type');
      this.type = t === 'username' ? 'username' : 'password';
    });
  }

  onSuccess(res: ApiResponse): void {
    if (!this.isBrowser) return;
    /* Old A10 parity: show the backend success message (incl. the masked
       phone/email) in a sweet-alert, then redirect to login on close. */
    showAuthSuccessSwal(res, this.translateService, () => this.onLogin());
  }

  onError(err: HttpErrorResponse): void {
    if (!this.isBrowser) return;
    showAuthErrorSwal(err, this.translateService);
  }

  onLogin(): void {
    this.router.navigate(['/login']);
  }

  onSignup(): void {
    this.router.navigate(['/signup']);
  }
}
